// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';

import type {UrlNode} from 'libs/model';
import {SocialIcon} from 'modules/Icon';
import {Link as Lx} from 'modules/Link';

import {getLinkProps} from './getLinkProps';

// types

type Props = ComponentProps<typeof Link> & {
  meta: UrlNode['meta'];
  service: keyof typeof getLinkProps;
};

// component

export function ShareLink(props: Props) {
  const {meta, service, ...rest} = props;
  const {name, icon, link, color} = getLinkProps[service](meta);

  return (
    <Link {...rest} href={link} style={{backgroundColor: color}}>
      <SocialIcon icon={icon} size={20} title={name} />
    </Link>
  );
}
// styles

export const Link = styled(Lx)`
  flex: 0 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.125rem;
  width: 2.5rem;
  height: 2.5rem;
  background-color: var(--gray-50);
  color: var(--white);
  transition: border-radius 100ms linear;

  &:hover {
    border-radius: 2rem;
  }
`;
